/**
 * product-trust-badges.js — fills any {day} token in a trust badge with the store's
 * live next-dispatch day, using the shared DispatchCountdown helper (same 3pm NZ
 * cutoff, weekend + holiday aware as the product shipping message). Only loaded when
 * a badge actually uses the token (see snippets/product-trust-badges.liquid).
 */
(function () {
  function fill() {
    var dc = window.DispatchCountdown;
    if (!dc || typeof dc.state !== 'function') return;
    var label = dc.state().dayLabel || 'today';
    var nodes = document.querySelectorAll('[data-ptb-day]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== label) nodes[i].textContent = label;
    }
  }

  function bind() {
    // Refresh every minute via the shared ticker (fires immediately on registration).
    if (window.DispatchCountdown && window.DispatchCountdown.onTick) {
      window.DispatchCountdown.onTick(fill);
      return true;
    }
    return false;
  }

  function init() {
    if (!document.querySelector('[data-ptb-day]')) return;
    if (bind()) return;
    // DispatchCountdown loads deferred and may not be ready yet — retry briefly.
    var tries = 0;
    var t = setInterval(function () {
      if (bind() || ++tries > 50) clearInterval(t);
    }, 100);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
